import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "./App";
import { createConsoleQueryClient } from "@/lib/query-client";
import { startThemeSync } from "@/lib/theme";
// The three self-hosted typefaces, before the stylesheet that uses them.
// index.html used to link Google Fonts for these; see app/fonts.css.
import "./fonts.css";
import "./styles.css";

const queryClient = createConsoleQueryClient();

startThemeSync();

const container = document.getElementById("root");
if (!container) throw new Error("Root container is missing from index.html.");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
